export const businessScore = {
  phoneNumber: '020 331 812 63',
  website: 'scorethebusiness.com',
  calendly: {
    followUp: 'https://calendly.com/businessscorebd/follow-up',
    investors: 'https://calendly.com/businessscorebd/investors-follow-up-call',
  },
} as const;
